import { isPrimaryPointer } from 'motion-dom';
function extractEventInfo(event) {
  return {
    point: {
      x: event.pageX,
      y: event.pageY
    }
  };
}
var addPointerInfo = function addPointerInfo(handler) {
  return function (event) {
    return isPrimaryPointer(event) && handler(event, extractEventInfo(event));
  };
};
export { addPointerInfo, extractEventInfo };